var INITIAL = {
    adults: 0,
    children: 0,
    other: 0,
    strollers: 0,
    wheelchairs: 0,
};
export function passengerReducer(state, action) {
    if (state === void 0) { state = INITIAL; }
    switch (action.type) {
        case 'UPDATE_RECEIVED':
            if (action.message.type === 'passengerCount') {
                return action.message.payload;
            }
    }
    return state;
}



//////////////////
// WEBPACK FOOTER
// ./src/components/Passengers/reducers.ts
// module id = 1827
// module chunks = 0